<template>
  <div class="list special-list">
    <!-- 下拉菜单显示时，页面fixed -->
    <div class="cover" v-show="selectStatus" @click="hide"></div>
    <!-- 下拉菜单部分 -->
    <div class="select-wrap activity-select-wrap clear" id='select-special'>
        <!-- 静态数据筛选 -->
        <div class="select-zonghe fl clear" @click="changeCover">
          <v-select v-model="model1" size="small" placeholder="排序" class="select-cont fl" style="width:.55rem" @on-change="change">
            <!--分类数据通过遍历sortArr获取-->
            <v-option class="select-item" v-for="item in sortArr"  :value="item.sortType" :key="item.sortType">
              <div class="" @click="request(0,industry,sortId,item.sortType,regionType,false)">
                {{ item.sortName }}<i class="iconfont duigou">&#xe648;</i>
              </div>
            </v-option>
          </v-select>
        </div>
        <!-- 分类筛选 -->
        <div class="select-type fl clear" @click="changeCover">
          <v-select v-model="model2" size="small" placeholder="分类"  class="select-cont fl" style="width:.55rem" @on-change="change">
            <!--分类数据通过遍历typeArr获取-->
            <v-option class="select-item" v-for="item in typeArr" :value="item.industryId" :key="item.industryId">
              <div class="" @click="request(0,industry,item.industryId,sort,regionType,false)">
                {{ item.typeName }}<i class="iconfont duigou">&#xe648;</i>
              </div>
            </v-option>
          </v-select>
        </div>
        <!-- 行业筛选 -->
        <div class="select-industry fl clear"  @click="changeCover">
          <v-select v-model="model3" size="small" placeholder="行业" class="select-cont fl" style="width:.55rem" @on-change="change">
            <v-option class="select-item" value="行业" key=" " :class="{'ivu-select-item-selected':industry == ''}">
              <div class="" @click="request(0,'',sortId,sort,regionType,false)">
                全部行业<i class="iconfont duigou">&#xe648;</i>
              </div>
            </v-option>
            <v-optionGroup v-for="item in industryList">
              <v-option class="parent-item" :value="item.name" :key="item.id">
                <div  @click="request(0,item.id,sortId,sort,regionType,false)">{{ item.name }}<i class="iconfont duigou fr" v-if="iconStatus">&#xe648;</i></div>
              </v-option>
              <v-option class="select-detail" v-if="item.children" v-for="detail in item.children" :value="detail.name" :key="detail.name">
                <div class=""  @click="request(0,detail.id,sortId,sort,regionType,false)">
                  {{detail.name}}<i class="iconfont duigou fr" v-if="iconStatus">&#xe648;</i>
                </div>
              </v-option>
            </v-optionGroup>
          </v-select>
        </div>
        <!-- 区域筛选 -->
        <div class="select-type fl clear" @click="changeCover">
          <v-select v-model="model4" size="small" placeholder="区域"  class="select-cont fl" style="width:.55rem" @on-change="change">
            <v-option class="select-item" value="全部" key="全部" :class="{'ivu-select-item-selected':regionType === ''}">
              <div class="" @click="request(0,industry,sortId,sort,'',false)">
                全部区域<i class="iconfont duigou">&#xe648;</i>
              </div>
            </v-option>
            <v-option class="select-item" value="海外" key="海外" :class="{'ivu-select-item-selected':regionType == '0'}">
              <div class="" @click="request(0,industry,sortId,sort,0,false)">
                海外<i class="iconfont duigou" v-if="iconStatus">&#xe648;</i>
              </div>
            </v-option>
          </v-select>
        </div>
    </div>
    <!-- 轮播图部分 -->
    <div class="swiper-wrap" id="swiper-special">
      <swiper :options="swiperOption" ref="mySwiper" class="swiper-list clear">
        <swiper-slide class="swiper-item" v-for="item in bannerList">
          <a :href="'/module/detail.html?source=knowledge&id=' + item.id">
            <img :src="resourceUrl + item.cover" alt="">
            <div class="text-cover">{{item.title}}</div>
          </a>
        </swiper-slide>
        <!-- 轮播的小圆点 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 主要内容列表部分 -->
    <div class="main-cont" id="cont-special">
      <ul class="cont-list">
        <li class="cont-item clear" v-for="item in knowledgeList ">
          <a :href="'/module/detail.html?source=knowledge&id=' + item.id" class="clear">
            <div class="left-img fl">
              <img :src="resourceUrl + item.cover" alt="">
            </div>
            <div class="right-text fl">
              <h4>{{item.title}}</h4>
              <p>
                <span class="label"><i class="iconfont">&#xe6c4;</i>{{item.label.replace(/\,/g, "、")}}</span>
                <span class="time fr">{{item.publishTime.substring(5,7)}}-{{item.publishTime.substring(8,10)}}</span>
              </p>
            </div>
          </a>
        </li>
      </ul>
      <!-- 滚动到底部显示没有更多啦 -->
      <div class="no-more-data" v-show="isLastPage">
        没有更多数据啦~
      </div>
    </div>
    <!-- 正在加载组件 -->
    <v-loading :status='status'></v-loading>
  </div>
</template>

<script>
import Loading from 'components/common/loading'; // 正在加载组件
import {swiper,swiperSlide} from 'vue-awesome-swiper'; // 分页、轮播图组件
import {Select,Option,OptionGroup} from 'iview'; // 下拉菜单组件

  export default {
    data(){
      return{
        status:false, // 用于控制正在加载显示/隐藏
        iconStatus:false, // 用於控制下拉菜單對勾的显示与隐藏
        selectStatus:false, // 用来控制页面无法滚动样式
        scrollDisable:false, // 判断是否是滚动状态
        isLastPage:false, // 用于显示没有更多数据
        clickStatus:false, // 用于区分是点击筛选还是无限加载
        industryVal:'', // 用于行业下拉菜单显示内容
        page:0,
        industry:'', // 行业参数
        sortId:'', // 求职、面试等参数
        sort:'', // 点赞、阅读等参数
        regionType:'', // 海外区域参数
        bannerList:[], // 头部轮播图列表数据
        industryList:[],  // 行业筛选列表数据
        knowledgeList:[], // 主要内容列表数据
        model1: '',
        model2: '',
        model3: '',
        model4: '',
        sortArr:[ // 静态筛选条件(点赞、阅读等)
          {sortType: '', sortName: '综合排序'},
          {sortType: 'viewCount,desc', sortName: '阅读最多'},
          {sortType: 'goodCount,desc', sortName: '点赞最多'},
          {sortType: 'commentCount,desc', sortName: '评论最多'},
        ],
        typeArr:[ // 分类搜索数据
          {industryId:'', typeName: '全部分类'},
          {industryId:1200, typeName: '求职信服务'},
          {industryId:1300, typeName: '面试服务'},
          {industryId:1400, typeName: '职业规划'},
          {industryId:1100, typeName: '简历服务'},
        ],
        regionArr:[
          {id:'',regionName:'全部'},
          {id:0,regionName:'海外'},
        ],
        swiperOption: { // 轮播图
          slidesPerView: 1,
          paginationClickable: true,
          autoplayDisableOnInteraction: true,
          pagination: '.swiper-pagination',
        },
      }
    },
    components:{
      'v-loading':Loading,
      'swiper':swiper,
      'swiperSlide':swiperSlide,
      'v-select':Select,
      'v-option':Option,
      'v-optionGroup':OptionGroup
    },
    methods:{
      changeCover(){
        // 当下拉菜单是显示状态时，cover一直显示,否则根据点击事件切换
        if($('.select-cont').hasClass('ivu-select-visible')){
          this.selectStatus = true;
        }else{
          this.selectStatus = !this.selectStatus;
          // this.selectStatus = false;
        }
      },
      // 点击cover自身让其隐藏
      hide(){
        $('.cover').css('display','none');
        this.selectStatus = false;
      },
      // 下拉菜单的回调函数，当选择数据发生变化时执行(点击筛选时，cover隐藏)
      change(){
        this.selectStatus = false;
        this.iconStatus = true; // 数据变化时，对勾显示
      },
      //banner部分内推数据请求
      reqBanner(){
        this.$http({
          method:'get',
          url:'/api/realknow/hot/bread/m',
        }).then(response => {
          this.bannerList = response.data.data;
        })
      },
      //行业数据请求
      reqIndustry(){
        this.$http({
          method:'get',
          url:'/api/college/industry/list?type=recommend',
          params:{
            platformCode:'m',
          }
        }).then(response => {
          this.industryList = response.data.data;
        })
      },
      //干货列表数据请求
      request(page,industry,sortId,sort,regionType,clickStatus){
        var _that = this;
        this.page = page;
        this.industry = industry;
        this.sortId = sortId;
        this.sort = sort;
        this.regionType = regionType;
        this.clickStatus = clickStatus;
        this.$http({
          method:'get',
          url:'/api/realknow',
          params:{
            platformCode:'m',
            page:this.page,
            size:10,
            'industry.id':this.industry,
            'sort.id':this.sortId,
            sort:this.sort,
            'regionType':this.regionType,
          }
        }).then(response => {
          if(!this.clickStatus) { // 如果是点击筛选,则改变articleList数组元素
            this.knowledgeList = response.data.data.content;
          }else {
            var arr = response.data.data.content;
            $.each(arr,function(i,item) { // 下拉加载knowledgeList数组继续增加元素
                _that.knowledgeList.push(item);
            })
          }
          this.isLastPage = response.data.data.last;
          this.status = true;
        })
      },
      // 实现无限滚动加载
      scrollMore(){
        var scrollTop = $(window).scrollTop();
        var height = $(document).height() - $(window).height();
        if(scrollTop >= height) {
          this.clickStatus = true; // 将状态设为下拉加载
          // 触发加载数据(如当前不是滚动状态，则执行加载更多函数)
          if(!this.scrollDisable) {
            this.page ++;
            this.loadMore();
          }
        }
      },
      loadMore(){
        if(!this.isLastPage){
           this.scrollDisable = true; // 加载函数执行时，滚动状态设为true
           this.status = false; // 滚动时再次显示正在加载...
           this.request(this.page,this.industry,this.sortId,this.sort,this.regionType,this.clickStatus); // 执行加载函数
           this.scrollDisable = false;  // 加载完成后，再次将滚动状态设为false
        }
      },
    },
    // 根据下拉菜单状态控制body是否fixed
    updated(){
      $('body,html').css('position',this.selectStatus ? 'fixed' : 'static');
    },
    mounted(){
      // 如果是从海外专题过来，默认选中海外
      if(window.location.href.indexOf('regionType') !== -1){
        this.iconStatus = true;
        this.regionType = this.GetQueryString('regionType');
        $('.select-type').find('.ivu-select-placeholder').text('海外');
      }
      this.reqBanner();
      this.reqIndustry();
      this.request(this.page,this.industry,this.sortId,this.sort,this.regionType,'');
      window.addEventListener('scroll',this.scrollMore); // 监听滚动条高度，加载函数
    }
  }
</script>

<style scoped lang="scss">
@import  "../../../sass/mixin";
@import  "../../../sass/listCommon";

</style>



// WEBPACK FOOTER //
// knowledge.vue?47a86182